<app-form-input
	[parentForm]="parentForm"

	[disabled]="disabled"
	[value]="radioButtonValue"

	[label]="step2.getspan7"
	[type]="'radio'"
	[rule]="'pattern_29|required'"
	[errorMessage]="{'required' : 'ctr_1082'}"
	[radios]="[
		{
			label: step2.procedureAdapteeO,
			value: procedureAdapteeOValue
		},
		{
			label: step2.procedureAdapteeR,
			value: procedureAdapteeRValue
		}
	]"
	[name]="radioButtonCtrlName"
>
</app-form-input>

<!---->

<span class="d-block" >{{ step2.getspan8 | translate }}</span>
<span class="d-block" >{{ step2.getspan9 | translate }}</span>

<app-form-input
	[parentForm]="parentForm"

	[disabled]="disabled"
	[value]="procedure.capaciteExercice"

	[label]="step2.capaciteExercice"
	[type]="'text'"
	[rule]="'minSize_5|maxSize_2000'"
	[name]="getUid() + '_SepAtt_capaciteExercice'"
>
</app-form-input>

{{ step2.getspan10 | translate }}

<app-form-input
	[parentForm]="parentForm"

	[disabled]="disabled"
	[value]="procedure.capaciteEcoFin"

	[label]="step2.capaciteEcoFin"
	[type]="'text'"
	[rule]="'minSize_5|maxSize_2000'"
	[name]="getUid() + '_SepAtt_capaciteEcoFin'"
>
</app-form-input>

{{ step2.getspan11 | translate }}

<app-form-input
	[parentForm]="parentForm"

	[disabled]="disabled"
	[value]="procedure.capaciteTech"

	[label]="step2.capaciteTech"
	[type]="'text'"
	[rule]="'minSize_5|maxSize_2000'"
	[name]="getUid() + '_SepAtt_capaciteTech'"
>
</app-form-input>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg1" [id]="getStepId() + rg1"></app-form-input-error>

<app-tech-achatFNS
	[uid]="getUid()"
	[parentForm]="parentForm"

	[disabled]="disabled"
	[techAchat]="procedure.techAchat"
>
</app-tech-achatFNS>

<!---->

<app-form-input
	[parentForm]="parentForm"

	[disabled]="disabled"
	[value]="procedure.dateReceptionOffres"
	[errorMessage]="{'required' : 'ctr_1019_jira'}"
	[label]="step2.dateReceptionOffres"
	[type]="'datetime'"
	[rule]="'required'"
	[name]="getUid() + '_SepAtt_dateReceptionOffres'"
>
</app-form-input> <!--//885-->
<!--<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg4"></app-form-input-error>-->
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg5" [id]="getStepId() + rg5"></app-form-input-error>

<app-pres-offresFNS
	[uid]="getUid()"
	[parentForm]="parentForm"

	[disabled]="disabled"
	[presOffres]="procedure.presOffres"
>
</app-pres-offresFNS>

<!---->

<app-type-oui-non-nb-candidat-reduitFNS-simple
	[uid]="getUid()"
	[parentForm]="parentForm"

	[disabled]="disabled"
	[nbCandidatReduit]="procedure.nbCandidatReduit"
></app-type-oui-non-nb-candidat-reduitFNS-simple>

<!---->

<app-type-oui-non
	[uid]="getUidAttributionSansNegociation()"
	[parentForm]="parentForm"
	[label]="step2.getspan15"
	[disabled]="disabled"
	[value]="procedure.attributionSansNegociation"
>
</app-type-oui-non>

<app-type-oui-non
	[uid]="getUidVarientes()"
	[parentForm]="parentForm"
	[label]="step2.getspan16"
	[disabled]="disabled"
	[value]="procedure.variantes"
>
</app-type-oui-non>

<!---->

<app-form-input
	[parentForm]="parentForm"

	[disabled]="disabled"
	[value]="procedure.categorieAcheteur"

	[label]="step2.categorieAcheteur"
	[type]="'text'"
	[rule]="'minSize_5|maxSize_2000'"
	[name]="getUid() + '_SepAtt_categorieAcheteur'"
>
</app-form-input>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg2" [id]="getStepId() + rg2"></app-form-input-error>

<!---->

<app-form-input
	[parentForm]="parentForm"

	[disabled]="disabled"
	[value]="procedure.criteresAttrib"

	[label]="step2.criteresAttrib"
	[type]="'text'"
	[rule]="'minSize_5|maxSize_2000'"
	[name]="getUid() + '_SepAtt_criteresAttrib'"
>
</app-form-input>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg3" [id]="getStepId() + rg3"></app-form-input-error>
